module.exports = __webpack_public_path__ + "img/delete.5b798b6c.svg";